import React from 'react';
import { NavLink } from 'react-router-dom';
import { useVoice } from '../context/VoiceContext';

const navItems = [
  { to: '/', label: '首页', icon: '🏠' },
  { to: '/medicines', label: '药品', icon: '💊' },
  { to: '/records', label: '记录', icon: '📋' },
  { to: '/settings', label: '设置', icon: '⚙️' },
];

export default function BottomNav() {
  const { speak } = useVoice();

  const handleClick = (label) => {
    speak(`已切换到${label}`);
  };

  return (
    <nav className="bottom-nav">
      {navItems.map(item => (
        <NavLink
          key={item.to}
          to={item.to}
          end={item.to === '/'}
          className={({ isActive }) => `nav-item ${isActive ? 'active' : ''}`}
          onClick={() => handleClick(item.label)}
        >
          <span className="nav-icon">{item.icon}</span>
          <span>{item.label}</span>
        </NavLink>
      ))}
    </nav>
  );
}
